import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import List from '../AnimationList';
import { cardClass } from './styles';
import { isRTL } from '../config';
var CollapseList = List(['collapse'], 'fast');

var Body =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Body, _PureComponent);

  var _super = _createSuper2(Body);

  function Body() {
    _classCallCheck(this, Body);

    return _super.apply(this, arguments);
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          collapsed = _this$props.collapsed,
          collapsible = _this$props.collapsible,
          onCollapse = _this$props.onCollapse,
          other = _objectWithoutProperties(_this$props, ["className", "collapsed", "collapsible", "onCollapse"]);

      var newClassName = classnames(cardClass('body', isRTL() && 'body-rtl'), className);
      if (!collapsible) return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, other, {
          className: newClassName
        }))
      );
      var onClick = typeof collapsed === 'boolean' ? onCollapse : undefined;
      return (
        /*#__PURE__*/
        React.createElement(CollapseList, {
          show: !collapsed
        },
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, other, {
          className: newClassName
        }), other.children, collapsible === 'bottom' &&
        /*#__PURE__*/
        React.createElement("div", {
          className: cardClass('foldup'),
          onClick: onClick
        },
        /*#__PURE__*/
        React.createElement("span", null))))
      );
    }
  }]);

  return Body;
}(PureComponent);

export default Body;